export default __webpack_public_path__ + "static/media/literalLibrary.63502e37.png";